import { IHeadings } from "./type";

const headings: IHeadings = {
  title: "Explore Careers",
  subTitle:
    "Join a team where your talents are valued, your ideas matter, and together, we shape a future of success.",
  highlightWord: "Explore",
};

export const careers = {
  imageUrl:
    "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/709158518279160_join-us-bg-web.svg&alt=bgWeb",
  mobileImageUrl:
    "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/215594357469342_join-us-bg-mob.svg&alt=joinusmob",
  headings,
};

export const bannerImages = {
  imageUrl:
    "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/17731133592713_break-barriers-web.svg&alt=break-barriers-web&",
  mobileImageUrl:
    "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/201952401527835_break-barrier-sm.svg&alt=breakbarriersm&q=20",
};

export const CareerTipImages = {
  webImageSrc:
    "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/709158676625795_join-us-tip-web.svg&alt=tipWeb",
  mobileImageSrc:
    "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/303765887667995_leftImg-sm.svg&alt=tipsm",
};

export const CareerGirlImages = {
  webImageSrc:
    "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/24366023510976_girl-web.svg&alt=girlW",
  mobileImageSrc:
    "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/24366023510976_girl-web.svg&alt=girlW",
};

export const seachIconSrc =
  "https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/dtdl/120388008731424_search.png&alt=searchIcon";

export const footerImages = {
  instagram: {
    href: "https://www.instagram.com/dtdllife/",
    imageUrl:
      "/assets/dtdl/insta.svg",
  },
  dtGurgaon: {
    href: "https://medium.com/deutsche-telekom-gurgaon",
    imageUrl:
      "/assets/dtdl/mediumLogo.svg",
  },
  linkedIn: {
    href: "https://www.linkedin.com/company/deutsche-telekom-digital-labs",
    imageUrl:
      "/assets/dtdl/linkedin.svg",
  },
};
